module.exports = __webpack_public_path__ + "img/sarawak.d94bb3bb.png";